export default __webpack_public_path__ + "static/media/market-gif1.ce0a286c.gif";